import { useRecoilValue } from 'recoil';
import { requestDataState } from 'recoilState/atoms/requestDataState';

export default function useSegmentation() {
    const state = useRecoilValue(requestDataState);
    return state.segmentation;
}
